module.exports = __webpack_public_path__ + "static/media/cloud_1.5dd6e725.png";